import React, { useState } from 'react';
import { Button, Box } from '@material-ui/core';
import { Add, ExpandMore, CreateNewFolder, NoteAdd } from '@material-ui/icons';
import { useRouteMatch } from 'react-router';
import { Link } from 'react-router-dom';
import { TooltipMenu } from '../../../../common/tooltip-menu';
import { CreateCategoryDialog } from './CreateCategoryDialog';

const AddNewButton = () => {
  const [open, setOpen] = useState(false);
  const [openCreateCategoryDialog, setOpenCategoryDialog] = useState(false);
  const match = useRouteMatch();

  return (
    <>
      <TooltipMenu
        open={open}
        onClose={() => setOpen(false)}
        title={
          <Box
            display='flex'
            flexDirection='column'
            alignItems='flex-start'
            style={{ padding: '5px 10px', justifyContent: 'flex-start' }}
          >
            <Button
              data-track='resources-add-new-menu-category-option'
              startIcon={<CreateNewFolder style={{ fontSize: '16px' }} />}
              onClick={() => {
                setOpen(false);
                setOpenCategoryDialog(true);
              }}
              style={{
                color: '#fff',
                textTransform: 'none',
                fontSize: '14px',
                fontWeight: 400,
                padding: '4px 8px',
                justifyContent: 'flex-start',
                width: '100%',
              }}
            >
              New Category
            </Button>
            <Link
              to={{
                pathname: match?.url ? `${match.url}/create-resource` : '',
                state: { returnSlug: match?.url ?? '' },
              }}
              style={{ textDecoration: 'none', color: 'inherit', width: '100%' }}
            >
              <Button
                data-track='resources-add-new-menu-resource-option'
                startIcon={<NoteAdd style={{ fontSize: '16px' }} />}
                onClick={() => setOpen(false)}
                style={{
                  color: '#fff',
                  textTransform: 'none',
                  fontSize: '14px',
                  fontWeight: 400,
                  padding: '4px 8px',
                  justifyContent: 'flex-start',
                  width: '100%',
                }}
              >
                New Resource
              </Button>
            </Link>
          </Box>
        }
      >
        <Button
          data-track='resources-add-new-menu-button'
          aria-controls='add-new'
          aria-haspopup='true'
          onClick={() => setOpen(!open)}
          style={{
            backgroundColor: '#7047EB',
            color: '#fff',
            borderRadius: '4px',
            padding: '4.5px 12px',
            fontSize: '12px',
            fontWeight: 600,
            textTransform: 'none',
            minWidth: 'auto',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Add style={{ fontSize: 16, marginRight: 4 }} />
          {'Add New'}
          <ExpandMore style={{ fontSize: 18, marginLeft: 4 }} />
        </Button>
      </TooltipMenu>
      <CreateCategoryDialog open={openCreateCategoryDialog} close={() => setOpenCategoryDialog(false)} />
    </>
  );
};

export { AddNewButton };
